import { apiGet } from './client'

export async function getAllSyncLogs(
  token: string,
  filters?: Record<string, any>,
) {
  const params = new URLSearchParams()
  if (filters) {
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        params.append(key, String(value))
      }
    })
  }
  const qs = params.toString()
  return apiGet(`/admin/sync-logs/all${qs ? `?${qs}` : ''}`, token)
}
